import React from "react";

type Props = {};

const AdminLogsPage = (props: Props) => {
	return <div>AdminLogsPage</div>;
};

export default AdminLogsPage;
